var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c("div", { staticClass: "popup", staticStyle: { zIndex: "200" } }, [
        _c("div", { staticClass: "content", attrs: { id: "licenseShow" } }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("language.license.showTitle")) +
                "\n            "
            ),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  _vm.isShow = false
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "personInfo-content" },
            [
              _c("span", {}, [
                _vm._v(_vm._s(_vm.$t("language.license.showTip")))
              ]),
              _vm._v(" "),
              _c("strong", [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.licenseCode) +
                    "\n                "
                ),
                _c("div", {
                  staticClass: "copy-code",
                  on: {
                    click: function($event) {
                      return _vm.copyCode()
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.isShow = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.common.ok")))]
              )
            ],
            1
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-833598bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-833598bc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/personal_center_popups/license_show_popup.vue
// module id = null
// module chunks = 